// Generation mode settings (ROS / HPI / MDM / Physical Exam / Plan of Care styles)
// must follow the encounter's ASSIGNED PROVIDER, not whoever clicks Generate.
// Front-desk and MA accounts rarely carry noteSettings, and stamping theirs onto
// the chat silently forces every backend mode switch to its default branch — e.g.
// the ROS collapses to the abbreviated one-liner (Tasks#333 / FE#1776).

export const MODE_SETTING_KEYS = [
  "hpiStyleMode",
  "hpiLengthMode",
  "mdmStyleMode",
  "mdmLengthMode",
  "rosMode",
  "physicalExamLengthMode",
  "planOfCareMode",
];

// Maps a user's profile generation settings to the "local:" context variables the
// note templates read. Unset settings stay undefined, matching the historical
// payload shape (JSON.stringify drops them).
export const buildModeSettings = (user) => {
  const defaults = user?.custom?.noteSettings?.default || {};
  const out = {};
  for (const key of MODE_SETTING_KEYS) {
    out["local:" + key] = defaults[key];
  }
  return out;
};

// chat.assignedTo is an array on list rows, a scalar on some update payloads, and
// absent on compact/preview rows (see useChats selectChat) — normalize to one id.
export const assignedUserId = (chat) => {
  const raw = chat?.assignedTo;
  if (Array.isArray(raw)) return raw[0] || null;
  return raw || null;
};

// Picks whose settings to stamp at generation time. The assigned provider wins
// only when they are a different user than the one generating AND their profile
// actually carries at least one generation setting; otherwise fall back to the
// clicking user (the historical behavior, and the only safe option when the
// assignee could not be resolved — offline, not a doctor, or not yet confirmed).
export const pickSettingsSource = (chat, authUser, findUserById) => {
  const assignedId = assignedUserId(chat);
  if (assignedId && authUser?.id && assignedId !== authUser.id && typeof findUserById === "function") {
    const assigned = findUserById(assignedId);
    const defaults = assigned?.custom?.noteSettings?.default;
    // Check only the keys this module stamps: an unrelated key under
    // noteSettings.default must not select a provider whose 7 mode values are all
    // empty — that would stamp all-undefined, which JSON serialization drops,
    // silently RETAINING the previous generator's stale modes on the chat.
    if (defaults && MODE_SETTING_KEYS.some((k) => defaults[k] != null && defaults[k] !== "")) {
      return assigned;
    }
  }
  return authUser;
};
